// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import {
    xDeclineOrderCallbacks,
    xDeclineOrderParameter,
    xDeclineOrderResponse,
    xngDeclineOrder,
} from "@vanmeter/App/Services/DeclineOrder";

type HandlerType = ApiHandlerDiscreteParameter<
    xDeclineOrderParameter & xDeclineOrderCallbacks,
    xDeclineOrderParameter,
    xDeclineOrderResponse
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        OrderNumber: props.parameter.OrderNumber,
        Reason: props.parameter.Reason,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await xngDeclineOrder(props.apiParameter);
        props.parameter.onSuccess?.();
    } catch (error) {
        if (isApiError(error)) {
            props.parameter.onError?.(error.errorJson?.message ?? error.errorMessage);
        }
    }
};

export const chain = [PopulateApiParameter, RequestDataFromApi];

const xDeclineOrder = createHandlerChainRunner(chain, "xDeclineOrder");
export default xDeclineOrder;
